/**
 * Created by lari on 26/04/2017.
 */
(function () {
  'use strict';
  angular.module('vcexam')
    .component('sampleexameditor', {
      restrict: 'E',
      bindings: {
        exam: '=',
        dialog: '<?'
      },
      templateUrl: 'vcexam/sampleexameditor-component.tpl.html',
      controllerAs: 'vm',
      controller: ['$log', 'vertxEventBusService', '$window', '$cookies', 'PrintHelper',
        function ($log, vertxEventBusService, $window, $cookies, PrintHelper) {
          let vm = this;
          vm.save = save;
          // vm.addBiopsyField = addBiopsyField;
          // vm.printBiopsyLabels = printBiopsyLabels;
          vm.finishEdit = finishEdit;
          vm.cancelEdit = cancelEdit;
          vm.addTrackerValue = addTrackerValue;

          // vm.clearDoctor = clearDoctor;
          vm.$onInit = function () {
            if (angular.isDefined(vm.exam) && vm.exam.hasOwnProperty('_id')) {
              $log.debug('sampleexameditor $onInit exam: ', vm.exam);
              vm.examcopy = angular.copy(vm.exam);
              vm.previewUrl = PrintHelper.examSamplePreviewUrl(vm.exam._id);
            }
            if (angular.isDefined(vm.dialog) && angular.isObject(vm.dialog)) {
              $log.debug('sampleexameditor $onInit dialog: ', vm.dialog);
              vm.dialog = angular.copy(vm.dialog);
            }
          };

          function finishEdit() {
            // add formated date for easy identification and display ordering
            vm.exam.lastestchange = moment().locale('de-at').format('lll');

            // vm.exam.postediting = false;

            if (vm.exam.$hasPendingActions()) {
              vm.exam.cancel();
            }

            $log.debug('finishEdit exam: ', vm.exam, angular.isFunction(vm.exam.$save));

            // vm.exam.$save();
            vm.exam.$save().$then(function () {
              $log.debug('sampleexamedit finishEdit, saving exam succeeded');
            }, function (err) {
              $log.error('sampleexamedit, saving exam failed:', err);
            });

          } // finishExam

          function cancelEdit() {
            vm.exam = angular.copy(vm.examcopy);
            if (angular.isDefined(vm.dialog)) {
              vm.dialog.close();
            }

          }


          function addTrackerValue(trackervalue) {
            $log.debug('exam editor addTrackervalue called for: ', trackervalue);
            if (angular.isUndefined(vm.exam.template.trackervalues)) {
              vm.exam.template.trackervalues = {};
            }
            // reminder: prefixing 'v' is necessary because numberonly string can not be converted into xml tags
            if (angular.isUndefined(vm.exam.template.trackervalues['v' + trackervalue.trackerid])) {
              vm.exam.template.trackervalues['v' + trackervalue.trackerid] = {name: trackervalue.name, entries: []};
            }
            vm.exam.template.trackervalues['v' + trackervalue.trackerid].entries.push(trackervalue.def);
          }

          function save() {
            $log.debug('sampleexameditor save called');
            // doing nothing, by design post exam changes do need to be synced accross browser,
            // but do require an additional pdf to be rendered
            if (vm.exam.$hasPendingActions()) {
              vm.exam.cancel();
            }
            vm.exam.$save().$then(function () {
              $log.debug('sampleexamedit, saving exam succeeded');
            }, function (err) {
              $log.error('sampleexamedit, saving exam failed:', err);
            });
          }
          
        }] // controller
    }); // component

// klammerfriedhof
}());
